enum NOTIFICATION_TYPE {
    SUCCESS = "success",
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info'
}

export default NOTIFICATION_TYPE;